import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c89b329a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weui-pull-refreshing-box" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "weui-pull-present-box" }

import {reactive, computed, ref} from "vue";


export default {
  __name: 'index',
  emits: ['refresh'],
  setup(__props, { emit: __emit }) {

const data = reactive({
  startY: '',    //保存touch时的Y坐标
  moveDistance: 0,    //保存向下滑动的距离
  moveState: 0,        //开始滑动到结束后状态的变化 0:下拉即可刷新 1:释放即可刷新 2:加载中
  duration: 0
})
let style = ref(computed(() => {
  return{
    transition: `${data.duration}ms`,
    transform: `translate3d(0,${data.moveDistance}px, 0)`
  }
}))
const touchStart = (e)=>{
  data.duration = 0 // 关闭动画
  data.moveDistance = 0 // 滑动距离归0
  data.startY = e.targetTouches[0].clientY  // 获得开始Y坐标
}
const touchMove = (e)=>{
  let centerContentScrollPageSt=$(".center-content .scroll-page")[0]?.scrollTop
  centerContentScrollPageSt = typeof centerContentScrollPageSt==="undefined"?0:centerContentScrollPageSt
  let centerScrollPageSt = $(".center.scroll-page")[0]?.scrollTop
  centerScrollPageSt = typeof centerScrollPageSt==="undefined"?0:centerScrollPageSt
  let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || centerContentScrollPageSt||centerScrollPageSt
  //首先判断有没有滚动条，如果有，下拉刷新就不能启用。
  if (scrollTop > 0) return

  let move = e.targetTouches[0].clientY - data.startY
  //判断手指滑动的距离，只有为正数才代表用户下拉了。
  if (move > 0) {
    //阻止默认事件，在微信浏览器中尤为有用。
    e.preventDefault()
    //增加滑动阻力的感觉
    data.moveDistance = Math.pow(move, 0.8)
    if (data.moveDistance > 50) {
      //如果滑动距离大于50 就告诉你，释放即可刷新
      if (data.moveState === 1) return
      data.moveState = 1
    } else {
      //否则 恢复原样
      if (data.moveState === 0) return
      data.moveState = 0
    }
  }
}
const emit = __emit
const touchEnd = (e)=> {
  // 只要手指拿开，加上结束时的动画，这里为300ms
  data.duration = 300
  if (data.moveDistance > 50) {
    //这里逻辑跟touchMove一样，但是需要真的加载数据了，那moveState变为2 所以加载动画在这出现
    data.moveState = 2
    //因为还没加载完，让加载动画显示着，所以这里移动距离为50
    data.moveDistance = 50
    emit('refresh', () => {
      //这里就是成功后的回调了，如果该函数被调用，那就以为着加载数据完成，所以状态要回到0，当然需要在父组件调用。
      data.moveState = 0
    })
  } else {
    //否则 恢复原样
    data.moveDistance = 0
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "pull-refresh",
    ref: "scrollBox",
    style: _normalizeStyle(_unref(style)),
    onTouchstart: touchStart,
    onTouchmove: touchMove,
    onTouchend: touchEnd
  }, [
    _createElementVNode("div", _hoisted_1, [
      (data.moveState < 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(data.moveState === 0 ? '下拉刷新頁面' : '释放以刷新頁面'), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, "正在重載..."))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 36))
}
}

}